<!--
  ~ Copyright 2020 Google LLC.
  ~ SPDX-License-Identifier: Apache-2.0
  -->

<div *ngIf="dataFound"
     [ngStyle]="{position: 'relative'}"
     (mouseup)="envsMouseUp()">
  <div class="env-header"
       [ngStyle]="{height: getTimerangeHeight() + 'px'}">
    <input
      id="timerange-start-input"
      type="datetime-local"
      [attr.value]="getLocalISOString(startTimestamp)"
      [attr.min]="getLocalISOString(minTimestamp)"
      [attr.max]="getLocalISOString(endTimestamp)"
      (input)="onStartTimestampChange(getTimestampFromEvent($event))"
    >
    &mdash;
    <input
      id="timerange-end-input"
      type="datetime-local"
      [attr.value]="getLocalISOString(endTimestamp)"
      [attr.min]="getLocalISOString(startTimestamp)"
      [attr.max]="getLocalISOString(maxTimestamp)"
      (input)="onEndTimestampChange(getTimestampFromEvent($event))"
    >
    <button id="reset"
            (click)="resetTimerange();">
      Reset
    </button>

    <div [ngStyle]="{display: 'inline-block', 'margin-right': '20px', 'float': 'right'}">
      <label for="vision-type">Select vision:</label>
      <select id="vision-type" (change)="updateColorVision($event.target.value);">
        <option value="normal">Normal vision</option>
        <option value="protanopia">Protanopia</option>
        <option value="deuteranopia">Deuteranopia</option>
        <option value="tritanopia">Tritanopia</option>
      </select>
    </div>

    <app-header [ngStyle]="{display: 'inline-block','float': 'right', 'margin-right': '20px'}"></app-header>
  </div>
  <div [ngStyle]="{display: 'inline-block', height: getTimelineHeight() + 'px'}">
    <svg xmlns="http://www.w3.org/2000/svg"
         id="top-timeline"
         [attr.width]="envWidth"
         [attr.height]="getTimelineHeight()"
         [ngStyle]="{left: TITLE_WIDTH}">
      <rect [attr.x]="0"
            [attr.y]="getTimelineHeight() / 2 + 8"
            [attr.width]="envWidth"
            [attr.height]="2"
            fill="gray"/>
      <circle *ngIf="shouldDisplayTimelineCircle()"
              id="cur-snapshot-line"
              [attr.cx]="getLineX() - 1"
              [attr.cy]="getTimelineHeight() / 2 + 9"
              [attr.r]="3"
              fill="gray"/>
      <text *ngFor="let timelinePoint of timelinePoints; let i = index"
            [attr.x]="timelinePoint.x"
            [attr.y]="9"
            [attr.text-anchor]="environmentService.getTimelinePointTextAlignment(i, timelinePoints)"
            [attr.fill]="getThemeTextColor()"
            font-size="12">
        {{ timelinePoint.timeString }}
      </text>
      <text *ngFor="let timelinePoint of timelinePoints; let i = index"
            [attr.x]="timelinePoint.x"
            [attr.y]="21"
            [attr.text-anchor]="environmentService.getTimelinePointTextAlignment(i, timelinePoints)"
            [attr.fill]="getThemeTextColor()"
            font-size="12">
        {{ timelinePoint.dateString }}
      </text>
      <line
        *ngFor="let timelinePoint of timelinePoints"
        [attr.x1]="timelinePoint.x"
        [attr.y1]="getTimelineHeight() - 2"
        [attr.x2]="timelinePoint.x"
        [attr.y2]="getTimelineHeight() / 2 + 4"
        stroke="gray"/>
    </svg>
  </div>
  <app-environment
    *ngFor="let environment of environments"
    [environment]="environment"
    [svgWidth]="envWidth"
    [colorDeficiency]="coloringService.colorDeficiency"
    [svgSmallHeight]="envSmallHeight"
    [svgBigHeight]="envBigHeight"
    [startTimestamp]="startTimestamp"
    [endTimestamp]="endTimestamp"
    [timelinePoints]="timelinePoints"
    [titleWidth]="TITLE_WIDTH"
    [curGlobalTimestamp]="curGlobalTimestamp"
    [draggedEnvName]="draggedEnvName"
    [envMarginBottom]="ENV_MARGIN_BOTTOM"
    (newEdgesEvent)="addEdges($event)"
    (startTimestampChange)="onStartTimestampChange($event)"
    (endTimestampChange)="onEndTimestampChange($event)">
  </app-environment>

  <div [ngStyle]="{display: 'inline-block', height: getTimelineHeight() + 'px'}">
    <svg xmlns="http://www.w3.org/2000/svg"
         id="bottom-timeline"
         [attr.width]="envWidth"
         [attr.height]="getTimelineHeight()"
         [ngStyle]="{left: TITLE_WIDTH}">
      <rect [attr.x]="0"
            [attr.y]="getTimelineHeight() / 2 - 12"
            [attr.width]="envWidth"
            [attr.height]="2"
            fill="gray"/>
      <circle *ngIf="shouldDisplayTimelineCircle()"
              id="cur-snapshot-line"
              [attr.cx]="getLineX() - 1"
              [attr.cy]="getTimelineHeight() / 2 - 11"
              [attr.r]="3"
              fill="gray"/>
      <text *ngFor="let timelinePoint of timelinePoints; let i = index"
            [attr.x]="timelinePoint.x"
            [attr.y]="getTimelineHeight() - 12"
            [attr.text-anchor]="environmentService.getTimelinePointTextAlignment(i, timelinePoints)"
            [attr.fill]="getThemeTextColor()"
            font-size="12">
        {{ timelinePoint.timeString }}
      </text>
      <text *ngFor="let timelinePoint of timelinePoints; let i = index"
            [attr.x]="timelinePoint.x"
            [attr.y]="getTimelineHeight()"
            [attr.fill]="getThemeTextColor()"
            [attr.text-anchor]="environmentService.getTimelinePointTextAlignment(i, timelinePoints)"
            font-size="12">
        {{ timelinePoint.dateString }}
      </text>
      <line
        *ngFor="let timelinePoint of timelinePoints"
        [attr.x1]="timelinePoint.x"
        [attr.y1]="2"
        [attr.x2]="timelinePoint.x"
        [attr.y2]="getTimelineHeight() / 2 - 3"
        stroke="gray"/>
    </svg>
  </div>
</div>
<div *ngIf="!dataFound">
  No input data found. <a [routerLink]="['/form']">Submit data</a>.
</div>
